import { movies, type Movie } from '@/mocks/movies';
import SectionHeading from './SectionHeading';
import MovieCard from './MovieCard';

const rankHint = [
  { label: '播放量', desc: '反映整体观看规模，是与大多数人同步的主要指标。' },
  { label: '讨论度', desc: '体现社交与社区里的活跃程度，口碑传播更快的影片更靠前。' },
  { label: '评分', desc: '综合整理的参考分值，用于比较影片之间的相对位置。' },
  { label: '完播率', desc: '衡量观看完整度，偏高的影片通常更「耐看」。' },
];

export default function HotMovies() {
  const hotMovies: Movie[] = [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 6);

  return (
    <section id="hot" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          dark
          kicker="Top Charts"
          title="热播大片：本期热度榜前六"
          desc="综合播放量、讨论度、评分与完播率等维度整理出的一般性榜单，用于呈现影片之间的相对热度，帮助你在选择时有个参照。"
        />

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {hotMovies.map((movie, index) => (
            <MovieCard key={movie.id} movie={movie} rank={index + 1} dark />
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {rankHint.map((item, index) => (
            <div key={item.label} className="p-5 rounded-lg bg-foreground-900 border border-foreground-800">
              <span className="font-heading text-3xl text-primary-500 leading-none">0{index + 1}</span>
              <h3 className="mt-3 text-sm md:text-base font-bold text-background-50">{item.label}</h3>
              <p className="mt-1 text-xs md:text-sm text-foreground-400 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}